import {
	Box,
	Button,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { Modal } from 'components';
import { useMenu } from 'hooks';
import React from 'react';

const PartnerItem = ({
	partner,
	isSelectable,
	selectedIds = [],
	handleClick,
	handleEditClick,
	deletePartner,
	reloadPartners,
	showAlertSuccess,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();
	const [openModal, setOpenModal] = React.useState(false);

	const handleOpenModal = () => {
		setOpenModal(true);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
	};

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={() => handleEditClick(partner)}>Edit</MenuItem>
			<MenuItem onClick={() => handleOpenModal()}>Delete</MenuItem>
		</Menu>
	);

	const handleDeleteClick = async (partner) => {
		await deletePartner(partner);
		showAlertSuccess('Partner has been deleted successfully.');
		handleCloseModal();
		reloadPartners();
	};

	const isSelected = selectedIds.includes(partner.id);

	return (
		<>
			<TableRow
				hover
				onClick={() => handleClick(partner)}
				sx={{ cursor: 'pointer' }}
			>
				{isSelectable && (
					<TableCell>
						<Checkbox
							checked={isSelected ? true : false}
							name="event"
							color="primary"
						/>
					</TableCell>
				)}
				<TableCell>
					<Typography variant="primary.text">{partner.name}</Typography>
				</TableCell>
				<TableCell>
					<Typography variant="primary.text">{partner.email}</Typography>
				</TableCell>
				<TableCell align="right">
					<IconButton
						onClick={(e) => {
							e.stopPropagation();
							handleToggleMenu(e);
						}}
					>
						<MoreHoriz />
					</IconButton>
					{renderMenu()}
				</TableCell>
			</TableRow>
			<Modal
				open={openModal}
				handleClose={handleCloseModal}
				title="Delete Partner"
				subtitle={`Are you sure you want to delete the partner ${partner.name}?`}
				actions={
					<>
						<Button color="primary" onClick={handleCloseModal}>
							Cancel
						</Button>
						<Button
							color="primary"
							variant="outlined"
							onClick={() => handleDeleteClick(partner)}
						>
							Delete
						</Button>
					</>
				}
			/>
		</>
	);
};

export default PartnerItem;
